/**
 * システムの mutaions
 */
const mutations = {

  /**
   * fatalErrorを更新します。
   */
  fatalError: (state, payload) => {
    state.fatalError = payload;
  },

  /**
   * toastを更新します。
   */
  toast: (state, payload) => {
    state.toast = payload;
  },

  /**
   * スマートフォンのレイアウト表示用flagを設定する
   */
  isMobile: (state, payload) => {
    state.isMobile = payload;
  },

  /**
   * スポット一覧にResultToolsを表示するフラグ (現在MapPageで使用)
   */
  setShowResultTools: (state, payload) => {
    state.showResultTools = payload;
  },
  /**
   * サイトIDを保持する
   */
  setSiteId: (state, payload) => {
    state.siteId = payload;
  },
  /**
   * カスタマイズデータを保持する
   */
  setCustomize: (state, payload) => {
    const langs = payload.data.lang.split('.');
    langs.forEach((lang) => {
      state.customize.langList.push(lang);
    });
    state.customize.providesForNtj = payload.data.provides_for_ntj;
    if (payload.data?.allowed_features) {
      state.customize.allowedFeatures = {
        canUseCarMultiRoute: payload.data.allowed_features.can_use_car_multi_route,
      };
    }
    if (payload.data.service_id) {
      state.customize.serviceId = payload.data.service_id;
    }
    state.customize.poiCategories = payload.data.poi_categories;
    state.customize.primaryColor = payload.data.primary_color;
    state.customize.secondaryColor = payload.data.secondary_color;
    state.customize.routeColor = payload.data.route_color;
    state.customize.accentColor = payload.data.accent_color;
    // rgba利用のための変換関数
    const hex2rgb = (hex) => {
      if (hex.slice(0, 1) === '#') hex = hex.slice(1);
      if (hex.length === 3) hex = hex.slice(0, 1) + hex.slice(0, 1) + hex.slice(1, 2) + hex.slice(1, 2) + hex.slice(2, 3) + hex.slice(2, 3);
      return [ hex.slice(0, 2), hex.slice(2, 4), hex.slice(4, 6) ].map(function (str) {
        return parseInt(str, 16);
      }).join(',');
    };
    state.customize.primaryColorRgb = hex2rgb(payload.data.primary_color);
    state.customize.logo = payload.data.logo;
    state.customize.officialSite = payload.data.official_site;
    state.customize.siteTopURL = payload.data.site_top_url;
    if (payload.data.overseas_site) {
      state.customize.overseasSite = {
        languages: payload.data.overseas_site.languages,
        // 参照時に言語コードを意識しないように吸収
        siteTop: {
          pc: payload.data.overseas_site.site_top.pc[payload.lang],
          sp: payload.data.overseas_site.site_top.sp[payload.lang],
        },
        logo: {
          pc: payload.data.overseas_site.logo.pc[payload.lang],
          sp: payload.data.overseas_site.logo.sp[payload.lang],
        },
        favicon: {
          pc: payload.data.overseas_site.favicon.pc[payload.lang],
          sp: payload.data.overseas_site.favicon.sp[payload.lang],
        },
      };
      if (payload.data.overseas_site.languages.some(language => language.toLowerCase() === payload.lang)) {
        if (payload.data.overseas_site.service_id) {
          state.customize.serviceId = payload.data.overseas_site.service_id;
        }
        // 現在指定している言語コードが海外向けサイトの対象である場合、色の設定を上書き
        state.customize.primaryColor = payload.data.overseas_site.color.primary;
        state.customize.secondaryColor = payload.data.overseas_site.color.secondary;
        state.customize.routeColor = payload.data.overseas_site.color.route;
        state.customize.accentColor = payload.data.overseas_site.color.accent;
      }
    }
    state.customize.favicon = payload.data.favicon;
    state.customize.title = payload.data.title;
    if (payload.data.pages_title?.length) {
      state.customize.pagesTitle = payload.data.pages_title.map(pageTitle => {
        // name に指定している言語コードのプロパティがあればタイトルの設定を上書き
        pageTitle.title = pageTitle.name && pageTitle.name[payload.lang] ? pageTitle.name[payload.lang] : pageTitle.title;
        return pageTitle;
      });
    }
    state.customize.description = payload.data.description;
    if (payload.data.initial_notice) {
      state.customize.initialNotice = payload.data.initial_notice[payload.lang];
    }
    const transports = payload.data.transport.split('.');
    transports.forEach((item) => {
      state.customize.transportList.push(item);
    });
    const transportsSection = payload.data.transport_section.split('.');
    transportsSection.forEach((item) => {
      state.customize.transportSectionList.push(item);
    });
    state.customize.poiDataSet = payload.data.poi_data_set;
    // カテゴリ検索
    state.customize.categories = payload.data.categories.map((category) => {
      category.type = 'mocha';
      if (category.children?.length) {
        category.children.map(child => {
          if (child.children?.length) {
            child.children.map(grandchild => {
              grandchild.type = 'mocha';
              return grandchild;
            });
          }
          child.type = 'mocha';
          return child;
        });
      }
      return category;
    });
    if (payload.data.original_spots) {
      const nassConditions = payload.data.original_spots.map((category) => {
        category.type = 'nass';
        return category;
      });
      state.customize.categories = state.customize.categories.concat(nassConditions);
    }
    if (payload.data.mocha_nass_categories) {
      // mocha と nass のパラメータを両方利用してカテゴリ検索を行うパラメータを mocha ベースのカテゴリ検索パラメータと結合
      const multiCategories = payload.data.mocha_nass_categories.map((category) => {
        category.type = 'mocha.nass';
        return category;
      });
      state.customize.categories = state.customize.categories.concat(multiCategories);
    }
    if (payload.data.recommend_spots_params) {
      state.customize.recommendSpotsParams = Object.fromEntries(new URLSearchParams(payload.data.recommend_spots_params));
    }
    if (payload.data.planning_support) {
      state.customize.planningSupport = {};
      if (payload.data.planning_support.gateway) {
        state.customize.planningSupport['gateway'] = {
          categoryName: payload.data.planning_support.gateway.category_name[payload.lang],
          condition: payload.data.planning_support.gateway.condition,
        };
      }
      if (payload.data.planning_support.goal) {
        state.customize.planningSupport['goal'] = {
          categoryName: payload.data.planning_support.goal.category_name[payload.lang],
          condition: payload.data.planning_support.goal.condition,
        };
      }
    }
    state.customize.linkWithRoute = payload.data.link_with_route;
    state.customize.linkWithRouteSections = payload.data.link_with_route_sections;
    state.customize.article = payload.data.article;
    state.customize.shioriBanner = payload.data.shiori_banner;
    state.customize.targetArea = payload.data.target_area;
    state.customize.poiSearchAreas = payload.data.poi_search_areas;
    state.customize.userType = payload.data.user_type;
    state.customize.cognito = payload.data.cognito_info;
    state.customize.loginRequired = payload.data.login_required;
    state.customize.informationHtml = payload.data.information_html;
    state.customize.accessiblePages = payload.data.accessible_pages;
    state.customize.indexPages = payload.data.index_pages;
    if (payload.data.recommend_spots_params) {
      state.customize.recommendSpotsParams = Object.fromEntries(new URLSearchParams(payload.data.recommend_spots_params));
    }
    state.customize.externalLinks = payload.data.external_links;
    state.customize.recommendedPlans = payload.data.recommend_plans;
    state.customize.recommendedPlanConditions = payload.data.recommend_plan_conditions;
    state.customize.recommendedUsers = payload.data.recommend_users;
    state.customize.planTopCondition = payload.data.plan_top_condition;
    state.customize.useTripNote = payload.data.use_trip_note;
    state.customize.sns = payload.data.sns;
    state.customize.affiliate = payload.data.affiliate;
    state.customize.informationUrl = payload.data.information_url;
    if (payload.data.gdpr) {
      state.customize.gdpr.use = payload.data.gdpr.use;
      state.customize.gdpr.privacyPolicyUrl = payload.data.gdpr.privacy_policy_url;
    }
    state.customize.guideMapParam.langList = payload.data.guide_map_param?.lang?.split('.') ?? [];
    state.customize.guideMapParam.logo = payload.data.guide_map_param?.logo ?? {};
    state.customize.guideMapParam.guiderParams = payload.data.guide_map_param?.guider_params ?? [];
    state.customize.guideMapParam.option = payload.data.guide_map_param?.option ?? {};
    state.customize.guideMapParam.displayFlags = payload.data.guide_map_param?.display_flags ?? { showFullScreenButton: true };
    state.customize.guideMapParam.spotSource = payload.data.guide_map_param?.spot_source ?? 'mocha';
    state.customize.guideMapParam.tag = payload.data.guide_map_param?.tag ?? '';
    state.customize.guideMapParam.supportedLanguages = payload.data.guide_map_param?.supported_languages ?? [];
    state.customize.guideMapParam.displayableAffiliates = payload.data.guide_map_param?.displayable_affiliates ?? [];
    state.customize.guideMapParam.searchRadius = payload.data.guide_map_param?.guide_map_search_radius ?? {};
    // Bandiera CMS 拡張 (左サイドパネル用)
    state.customize.guideMapParam.headlineImageUrl = payload.data.guide_map_param?.headline_image_url ?? '';
    state.customize.guideMapParam.selectors = payload.data.guide_map_param?.selectors ?? [];
    state.customize.guideMapParam.filters = payload.data.guide_map_param?.filters ?? [];

    if (payload.lang !== 'ja') {
      state.customize.title = payload.data['title_' + payload.lang];
      state.customize.description = payload.data['description_' + payload.lang];

      if (state.customize.categories?.length) {
        state.customize.categories = state.customize.categories.filter(category => (category['name_' + payload.lang]));
        state.customize.categories.forEach((category) => {
          category.name = category['name_' + payload.lang];
          if (category.children?.length) {
            category.children.forEach(child => {
              child.name = child['name_' + payload.lang];
              if (child.children?.length) {
                child.children.forEach(grandchild => {
                  grandchild.name = grandchild['name_' + payload.lang];
                });
              }
            });
          }
        });
      }

      if (state.customize.linkWithRouteSections) {
        const sectionTypes = [
          'transport_section',
          'transport_provider',
          'transport_line',
        ];
        sectionTypes.forEach((sectionType) => {
          if (state.customize.linkWithRouteSections[sectionType]) {
            state.customize.linkWithRouteSections[sectionType].text = state.customize.linkWithRouteSections[sectionType]['text_' + payload.lang];
            state.customize.linkWithRouteSections[sectionType].link = state.customize.linkWithRouteSections[sectionType]['link_' + payload.lang];
          }
        });
      }

      if (state.customize.poiSearchAreas) {
        state.customize.poiSearchAreas = state.customize.poiSearchAreas.filter(item => (item['name_' + payload.lang]));
        state.customize.poiSearchAreas.forEach((item) => {
          item.name = item['name_' + payload.lang];
          item.children = item.children.filter(child => (child['name_' + payload.lang]));
          item.children.forEach((child) => {
            child.name = child['name_' + payload.lang];
            child.children = child.children.filter(grandChild => (grandChild['name_' + payload.lang]));
            child.children.forEach((grandChild) => {
              grandChild.name = grandChild['name_' + payload.lang];
            });
          });
        });
      }

      if (state.customize.linkWithRoute) {
        state.customize.linkWithRoute.link = state.customize.linkWithRoute['link_' + payload.lang];
        state.customize.linkWithRoute.dom = state.customize.linkWithRoute['dom_' + payload.lang];
      }

      if (Object.keys(state.customize.gdpr).length > 0) {
        state.customize.gdpr.privacyPolicyUrl = payload.data.gdpr['privacy_policy_url_' + payload.lang];
        state.customize.gdpr.gdprPrivacyPolicyUrl = payload.data.gdpr['gdpr_privacy_policy_url_' + payload.lang];
      }
    }
  },
  /**
   * エラーダイアログ（強制サイトTOP遷移）表示フラグ
   */
  setPageAccessErrorDialog: (state, payload) => {
    state.showPageAccessErrorDialog = payload;
  },

  /**
   * エラーダイアログ（強制サイトTOP遷移）タイトル
   */
  setPageAccessErrorDialogContents: (state, payload) => {
    state.pageAccessErrorDialog = payload;
  },
  /**
   * ユーザーIDを保持する（Cognito）
  */
  setUserId: (state, payload) => {
    state.userId = payload;
  },
};

export { mutations as default };
